import { RolesActionsTypes } from "../types/Roles.reducer.types";

export function createSuccess(message) {
  return {
    type: RolesActionsTypes.CREATE_SUCCESS,
    payload: { message }
  };
}

export function createFailure(message) {
  return {
    type: RolesActionsTypes.CREATE_FAIL,
    payload: { message }
  };
}

export function editSuccess(message) {
  return {
    type: RolesActionsTypes.EDIT_SUCCESS,
    payload: { message }
  };
}

export function editFailure(message) {
  return {
    type: RolesActionsTypes.EDIT_FAIL,
    payload: { message }
  };
}

export function listRequest(filter, { isAdmin = false }) {
  return {
    type: RolesActionsTypes.LIST_REQUEST,
    payload: { filter, isAdmin }
  };
}

export function listSuccess({ list }) {
  return {
    type: RolesActionsTypes.LIST_SUCCESS,
    payload: { list }
  };
}

export function listFailure() {
  return {
    type: RolesActionsTypes.LIST_FAIL
  };
}
